import CookieRepository from 'frontcore/domain/cookies/model/CookieRepository'
import { AuthorizationCredentialsServiceFactory } from 'frontcore/domain/authorization/factory'
import { getUrlQueryParameterFromObject } from 'frontcore/utils/communications/apiClient'

class UseSSOLogout {

  async didFullFillLogout (redirectUri?: string) {
    const cookieRepo = new CookieRepository()
    const idToken = cookieRepo.get('idToken')
    const params = getUrlQueryParameterFromObject({
      'id_token_hint': idToken,
      'post_logout_redirect_uri': redirectUri,
    })
    cookieRepo.delete('idToken')
    const url = new URL(`${API_URL}/oauth-logout/?${params}`)
    window.location.href = url.toString()
  }

  use (redirectUri?: string) {
    const logout = async () => {
      const loginService = AuthorizationCredentialsServiceFactory.build()
      loginService.logout()
      this.didFullFillLogout(redirectUri)
    }

    return {
      logout,
    }
  }
}

export default UseSSOLogout
